import { Button, message, Pagination, Spin, Tabs } from 'antd'
import TabPane from 'antd/es/tabs/TabPane'
import React, { useEffect, useState } from 'react'
import CardBlogs from '../../../components/CardBlogs';
import { Link } from 'react-router-dom';
import Filter from './../../../components/Filter';
import { useSelector } from 'react-redux';
import axios from 'axios';

function Blogs() {
  const [activeKey, setActiveKey] = useState("1");
  const API_URL = import.meta.env.VITE_API_URL;
  const [Blogs, setBlogs] = useState([]);
  const [BlogsDeleted, setBlogsDeleted] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [loading, setLoading] = useState(false);
  const accessToken = useSelector((state) => state.user.accessToken);
  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
  const [selectedFilters, setSelectedFilters] = useState({ date: null, category: null, search: null });
  const [categoryList, setCategoryList] = useState([])
  const [FlagFetch, setFlagFetch] = useState([])

  const handleTabChange = (key) => {
    setActiveKey(key);
  };
  const fetchBlogs = async (page = 1, pageSize = 10, date = null, search = null, category = null) => {
    setLoading(true);
    try {
      let url = `${API_URL}Blogs/get-Blogs?limit=${pageSize}&page=${page}`;
      // console.log(category);
      // Add filters to the API URL
      if (date) {
        url += `&date=${date}`; // Add the date filter
      }
      if (search) {
        url += `&search=${search}`; // Add the search filter
      }
      if (category) {
        url += `&categoryId=${category}`; // Add the search filter
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const { totalCount } = response.data;
      setBlogs(response.data.AllBlogs.slice().reverse());
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: totalCount,
      });
    } catch (error) {
      console.error("Error fetching blogs:", error);
      message.destroy();
      message.error('Failed to fetch blogs');
    } finally {
      setLoading(false);
    }
  };
  const fetchBlogsDeleted = async (page = 1, pageSize = 10, date = null, search = null, category = null) => {
    setLoading(true);
    try {
      let url = `${API_URL}Blogs/get-Blogs?limit=${pageSize}&page=${page}&deleted=true`;
      // console.log(category);
      // Add filters to the API URL
      if (date) {
        url += `&date=${date}`; // Add the date filter
      }
      if (search) {
        url += `&search=${search}`; // Add the search filter
      }
      if (category) {
        url += `&categoryId=${category}`; // Add the search filter
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const { totalCount } = response.data;
      console.log(response.data.AllBlogs)
      setBlogsDeleted(response.data.AllBlogs.slice().reverse());
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: totalCount,
      });
    } catch (error) {
      console.error("Error fetching blogs:", error);
      message.destroy();
      message.error('Failed to fetch blogs');
    } finally {
      setLoading(false);
    }
  };
  const [filterDropdowns, setFilterDropdowns] = useState([
    {
      title: "Date",
      type: "date",
    },
    {
      title: "Category",
      type: [],
    },

  ]);
  const handleFilterChange = (key, value) => {
    let updatedFilters = { ...selectedFilters };
    let errorMessageShown = false;
    // console.log("key", key)
    // console.log("value", value)
    // console.log("categoryList", categoryList)
    if (key === "Category") {
      const categoryId = value ? categoryList.find(ph => ph.name === value)?.id : null;
      updatedFilters.category = categoryId;
    }
    if (key === "Date") {
      const Date = value ? value : null;
      updatedFilters.date = Date;
    }

    if (key === "search") {
      let search = null;

      if (value && value.trim().length > 0) {
        const searchValue = value.trim();

        if (/\d/.test(searchValue)) {
          message.destroy();
          message.error("Search term must not contain numbers.");
          errorMessageShown = true;
        } else if (searchValue.length > 4) {
          search = searchValue;
        }
      }

      updatedFilters.search = search;
    }

    if (key === "") {
      fetchBlogs(1, pagination.pageSize); // Reset filters and fetch blogs
      fetchBlogsDeleted(1, pagination.pageSize); 
      updatedFilters = {};
    }

    setSelectedFilters(updatedFilters);

    // Fetch blogs with date and search filters applied
    fetchBlogs(1, pagination.pageSize, updatedFilters.date, updatedFilters.search, updatedFilters.category);
  };
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}Diseases/get-diseases`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const Diseases = response.data.Diseases.map(d => ({
        id: d.id,
        name: d.name,
      }));
      const DiseasesList = Diseases.map(Diseases => Diseases.name);

      setCategoryList(Diseases)
      setFilterDropdowns([
        {
          title: "Category",
          options: DiseasesList,
        },
        {
          title: "Date",
          type: "date",
        },

      ]);
    } catch (error) {
      console.error("Error fetching categories:", error);
      return [];
    }
  }

  useEffect(() => {
    fetchCategories()
  }, [])
  useEffect(() => {
    fetchBlogs()
    fetchBlogsDeleted()
  }, [FlagFetch])
  const handlePaginationChange = (page, pageSize) => {
    fetchBlogs(page, pageSize, selectedFilters.date, selectedFilters.search, selectedFilters.category);
  };


  const [filterOptions, setFilterOptions] = useState({})
  useEffect(() => {
    fetchBlogs(1, pagination.pageSize, selectedFilters.date, selectedFilters.search, selectedFilters.category);
  }, [pagination.pageSize, selectedFilters]);

  useEffect(() => {
    fetchBlogs(pagination.current, pagination.pageSize, selectedFilters.date, selectedFilters.search, selectedFilters.category);
  }, [pagination.pageSize, selectedFilters]);

  return (
    <Tabs
      activeKey={activeKey}
      onChange={handleTabChange}
      tabBarExtraContent={
        userType == 4 ? null : <Link to="CreateBlogs"><Button style={{ padding: "20px 33px", borderRadius: "2px" }} type="primary">+ Add Blog</Button></Link>
      }
      tabBarStyle={{ marginBottom: 0 }}
    >
      <TabPane
        tab={
          <span
            style={{
              fontSize: 20,
              fontWeight: activeKey === "1" ? 600 : 400,
              color: activeKey === "1" ? "#1C1C1C" : "#1C1C1C",
            }}
          >
            Recent Blog
          </span>
        }
        key="1"
      >
        <br />
        <Filter
          filterOptions={filterOptions}
          setFilterOptions={setFilterOptions}
          onFilterChange={handleFilterChange}
          dropdowns={filterDropdowns}
          searchBarPlaceholder='Search Blogs'
        />

        <div className="mt-5">
          <Spin spinning={loading}>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {Blogs.map((blog) => (
                <CardBlogs key={blog.id} data={blog}  setFlagFetch={setFlagFetch}/>
              ))}
            </div>
          </Spin>
          <div className="mt-4">
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={handlePaginationChange}
              showSizeChanger
              onShowSizeChange={handlePaginationChange}
            />
          </div>
        </div>

      </TabPane>
      <TabPane
        tab={
          <span
            style={{
              fontSize: 20,
              fontWeight: activeKey === "2" ? 600 : 400,
              color: activeKey === "2" ? "#1C1C1C" : "#1C1C1C",
            }}
          >
            History Blogs
          </span>
        }
        key="2"
      >
        <br />
        <Filter
          filterOptions={filterOptions}
          setFilterOptions={setFilterOptions}
          onFilterChange={handleFilterChange}
          dropdowns={filterDropdowns}
          searchBarPlaceholder='Search Blogs'
        />

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {BlogsDeleted.map((blog) => (
            <CardBlogs key={blog.id} data={blog} isHistoryBlogs={true} setFlagFetch={setFlagFetch}/>
          ))}
        </div>
      </TabPane>
    </Tabs>
  )
}

export default Blogs
